const BeautyFilterSkeletons: React.FC = () => {
  return (
    <div className="absolute bottom-0 z-[11] flex w-full flex-col rounded-t-lg bg-[#121212] text-white">
      {/* BeautyFilterTitle */}
      <div className="flex h-16 items-center gap-2 p-4 typography-headline-lg">
        <div className="h-6 w-14 animate-pulse rounded-lg bg-white/20" />
      </div>

      {/* BeautyFilterTabs */}
      <div className="flex max-h-[120px] items-start gap-4 overflow-x-hidden px-4 pb-4">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="relative flex h-[104px] w-[72px] flex-col items-center gap-2">
            <div className="backdrop-blur-[32px ] flex h-[72px] w-[72px] animate-pulse items-center justify-center rounded-full bg-white/20"></div>
            <div className="h-5 w-12 animate-pulse rounded-lg bg-white/20" />
          </div>
        ))}
      </div>

      {/* BeautyFilterMenu */}
      <div className="flex h-14 w-full items-center gap-3 bg-[#222222] px-4">
        <div className="h-6 w-40 animate-pulse rounded-lg bg-white/20" />
      </div>
      {Device.name === 'iOS' && <div className="h-[var(--sab)] w-full bg-[#222222]" />}
    </div>
  );
};

export default BeautyFilterSkeletons;
